import { StorageData } from "../storage-data";



export interface CompanyLanguage {
  i18n: string;
}

export interface ApplicationState {
  companyLanguage: StorageData<CompanyLanguage | null, null | string>;
  companyCurrency: StorageData<CompanyLanguage | null, null | string>;
}

export const INITIAL_STATE: ApplicationState = {
  companyLanguage: {
    data: null,
    loading: false,
    error: null,
  },
  companyCurrency: {
    data: null,
    loading: false,
    error: null,
  },
};

export enum ApplicationActionTypes {

  CHANGE_USER_LANGUAGE = "@application/CHANGE_USER_LANGUAGE",
  CHANGE_USER_LANGUAGE_SUCCESS = "@application/CHANGE_USER_LANGUAGE_SUCCESS",
  CHANGE_USER_LANGUAGE_ERROR = "@application/CHANGE_USER_LANGUAGE_ERROR",

  CHANGE_COMPANY_LANGUAGE = "@application/CHANGE_COMPANY_LANGUAGE",
  CHANGE_COMPANY_LANGUAGE_SUCCESS = "@application/CHANGE_COMPANY_LANGUAGE_SUCCESS",
  CHANGE_COMPANY_LANGUAGE_ERROR = "@application/CHANGE_COMPANY_LANGUAGE_ERROR",

  CHANGE_COMPANY_CURRENCY = "@application/CHANGE_COMPANY_CURRENCY",
  CHANGE_COMPANY_CURRENCY_SUCCESS = "@application/CHANGE_COMPANY_CURRENCY_SUCCESS",
  CHANGE_COMPANY_CURRENCY_ERROR = "@application/CHANGE_COMPANY_CURRENCY_ERROR"
  
}
